module.exports = __webpack_public_path__ + "components/page-header/static/icon-x-e21725a2cf3030af82fa428858051660.svg";